<template>
  <b-modal v-model="modal" title="Resultado - Enquete" size="xl">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ poll.description }}</h4>
            <!-- Bar Chart -->
            <apexchart
              v-show="!loading"
              class="apex-charts-modal"
              height="380"
              type="bar"
              ref="pollChart"
              dir="ltr"
              :series="series"
              :options="chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Fechar</b-button>
      <b-button variant="primary" @click="openFullChart()" v-if="!loading">Fullscreen</b-button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import http from '@/http'

export default {
  components: { Loading },
  data () {
    return {
      loading: true,
      modal: false,
      pollId: null,
      poll: {},
      answers: [],
      series: [{
        data: []
      }]
    }
  },
  methods: {
    open (pollId) {
      this.pollId = pollId
      this.modal = true
      this.loading = true
      if (pollId) {
        this.getInitPoll()
        this.connectSocket()
        return
      }
      this.loading = false
    },
    close () {
      this.pollId = null
      this.answers = []
      this.poll = {}
      this.modal = false
    },
    openFullChart () {
      let routeData = this.$router.resolve({ name: 'room-poll-chart', params: { pollId: this.pollId } })
      window.open(routeData.href, '_blank')
    },
    getInitPoll () {
      http.get(`/admin/charts/poll/${this.pollId}`).then((response) => {
        if (response.data.data.id) {
          this.poll = response.data.data
          this.answers = response.data.result.map(o => {
            return o.option
          })
          const totais = response.data.result.map(o => {
            return o.porcentagem
          })
          this.series[0].data = totais
          this.loading = false
        }
      }).then(() => {
        this.loading = false
      }).catch((error) => {
        console.error(error)
        this.loading = false
      })
    },
    connectSocket () {
      this.$pusher.subscribe(`chart-poll.${this.pollId}`).bind('ChartPoll', (response) => {
        if (response.data.id) {
          const totais = response.result.map(o => {
            return o.porcentagem
          })
          this.$refs.pollChart.updateSeries([{
            data: totais
          }])
        }
      })
    }
  },
  beforeMount () {
  },
  mounted () {
    // this.getInitPoll()
    // Echo.channel('chart-quiz.' + this.sala)
    //   .listen('ChartQuiz', (e) => {
    //     if (e.data.id) {
    //       const totais = e.resultado.map(o => {
    //         return o.porcentagem
    //       })
    //       this.$refs.chart.updateSeries([{
    //         data: totais
    //       }])
    //     }
    //   })
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          height: 380,
          toolbar: {
            tools: {
              zoomin: true,
              zoomout: true
            }
          },
          animations: {
            enabled: true,
            easing: 'bar',
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        plotOptions: {
          bar: {
            barHeight: '50%',
            columnWidth: '50%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            }
          }
        },
        colors: ['#008ffb', '#7081ce', '#34c38f', '#a157bf', '#b5704f'],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#FFF']
          },
          fill: {
            colors: ['#FFF']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ': ' + val + '%'
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        legend: {
          show: true,
          fontSize: '16px',
          offsetY: 0
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.answers,
          labels: {
            tickAmount: 10,
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        title: {
          text: 'Respostas',
          align: 'center',
          floating: true,
          style: {
            color: '#3c4b64'
          }
        },
        tooltip: {
          enabled: false,
          theme: 'dark',
          x: {
            enabled: false,
            show: false
          },
          y: {
            show: true
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.apex-charts-modal {
    min-height: 10px !important;
    text {
        fill: #FFF !important;
    }
    .apexcharts-canvas {
        margin: 0 auto;
    }
}
.apexcharts-yaxis,
.apexcharts-xaxis {
  text {
      fill: #FFF !important;
  }
}
</style>
